import querystring from 'querystring';
import { selector } from 'recoil';
import axios from '../../common/axiosInterceptor';
import { user } from '../atoms/user';
import { phoneSearch } from '../atoms/phoneSearch';
// import { currentCountry } from '../atoms/currentCountry';

export const phoneNumberSearch = selector({
  key: 'phoneNumberSearch',
  get: async ({ get }) => {
    try {
      // subscribed to team name atom that is created upon submition of team name change
      const formData = get(phoneSearch);
      const storageUser = get(user);
      // const currCountry = get(currentCountry);
      if (formData.pattern.length >= 1 || formData.cc.length >= 1) {
        const requestBody = {
          call: 'phonenumbersearch',
          cc: formData.cc,
          pattern: formData.pattern,
          sms: formData.sms,
          businessid: storageUser.businessid,
          apiKey: storageUser.apikey,
        };
        const stringed = querystring.stringify(requestBody);
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          withCredentials: true,
        };
        const url = `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php`;
        const result = await axios.post(url, stringed, config);
        return result;
      } else {
        const result = [];
        return result;
      }
    } catch (error) {
      throw error;
    }
  },
});
